export const RetailsTestID = {
    WRAPPER: 'retails-wrapper',
    CITY_SEARCH: 'retails-city-search',
    WEEKEND_FILTER: 'retails-weekend-filter',
    WEEKEND_SATURDAY: 'retails-weekend-saturday',
    WEEKEND_SUNDAY: 'retails-weekend-sunday',
    MAP: 'retails-map',
    CITY_SEARCH_QUICK_LINKS: 'retails-city-search-quick-links',
    CITY_SEARCH_SUGGESTIONS: 'retails-city-search-suggestions',
    CITY_SEARCH_SUGGESTION_ITEM: 'retails-city-search-suggestion-item',
    SALON_LIST: 'retails-salon-list',
    SALON_LIST_NOT_FOUND: 'retails-salon-list-not-found',
    SALON_LIST_ITEM: 'retails-salon-list-item',
    SALON_INFO: 'retails-salon-info',
    SALON_INFO_ALERT: 'retails-salon-info-alert',
    SALON_INFO_WORK_TIME: 'retails-salon-info-work-time',
    SALON_GO_BACK: 'retails-salon-go-back',
};
